import { Container } from '®shared/reading-list/models';

import { ContainerActionTypes, ContainerActions } from './container.actions';

export function containerEntityReducer(
  state: Container,
  action: ContainerActions,
): Container {
  switch (action.type) {
    case ContainerActionTypes.CONTAINER_INITIALISED: {
      return action.payload.container;
    }

    default: {
      return state;
    }
  }
}
